import React, { useEffect, useState } from "react";
import { Drawer, Layout } from "antd";
import { Link, Outlet } from "react-router-dom";
import SettingsSideMenu from "../components/layout/SettingsSideMenu";
import Theme from "../theme/Theme";
import SetupSideMenu from "../components/layout/SetupSideMenu";
import MainHeader from "../components/layout/MainHeader";
import useNavigationHistory from "../hooks/useNavigationHistory";

const { Content, Sider } = Layout;

function SetupLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const proWidth = document.body.clientWidth;

  // Track navigation history
  useNavigationHistory();

  useEffect(() => {
    /*In tab view collapse menu when loaded*/
    if (proWidth < 720) {
      setCollapsed(true);
    }
  }, []);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/*Main side menu*/}
      <Sider
        collapsible
        collapsed={collapsed}
        trigger={null}
        breakpoint="lg"
        style={{
          height: "100vh",
          overflow: "hidden",
        }}
        className="transparent-scroll hidden sm:block th-bg-side-menu"
      >
        <Link to="/setup-account/overview">
          <div className="logo" />
        </Link>
        <SetupSideMenu collapsed={collapsed} />
      </Sider>
      {/*Mobile side menu*/}
      <Drawer
        width="280"
        closable={false}
        placement="left"
        onClose={() => setCollapsed(true)}
        visible={!collapsed}
        className="sm:hidden"
        style={{ padding: 0 }}
        bodyStyle={{ backgroundColor: Theme().sideMenu, padding: 0 }}
      >
        <div className="logo" />
        <SettingsSideMenu collapsed={collapsed} />
      </Drawer>
      <Layout className="site-layout">
        <MainHeader
          openMenu={() => setCollapsed(!collapsed)}
          menu={collapsed}
        />
        <Outlet />
      </Layout>
    </Layout>
  );
}

export default SetupLayout;
